<form [formGroup]="frmCrmUser">
  <div>
    <label class="field__label">User</label>
    <app-searchable-select multiple formControlName="user" [items]="users"
      displayField="userFullName" placeholder="User" searchPlaceholder="Search users…"
      (selectionChange)="onUsersChanged($event)"></app-searchable-select>
  </div>
</form>
